<template>
  <div v-if="!zoomPanelData" class="matrix-board d-flex flex-column" ref="dashboard">
    <div ref="panel" v-for="(item, i) in panels" :key="i"
      :style="{ left: item.left, top: item.top, width: item.width, height: item.height }">
      <video-panel :panelData="item" @zoom-click='zoomPanelClick'></video-panel>
    </div>
  </div>

  <div v-else class="matrix-board" ref="dashboard" :class="getMobileZoomCss()">
    <video-panel :panelData="zoomPanelData" @zoom-click='zoomPanelClick' ></video-panel>
  </div>
</template>

<script>
import VideoPanel from './VideoPanel.vue'
import MobileDetect from '../utils/mobileDetect'
import { mapState, mapGetters } from 'vuex'

export default {
  props: ['groupData', 'panelWidth'],
  data() {
    return {
      panels: [],
      zoomPanelData: null,
     
    }
  },
  watch: {
    panelWidth() {
      this.setupPanel()
    },
    groupData() {
      this.setupPanel()
    }
  },
  computed: {
    ...mapState("mobileDetect", { isMobileDevice: "isMobileDevice" }),

  },
  methods: {
    setupPanel() {
      if (this.groupData) {
        const panelNumber = this.groupData.length
        let panelCols = this.groupData.length === 1 ? 1 : MobileDetect.isMobileDevice() ? 1 :  Math.ceil(Math.sqrt(panelNumber))
        let panelRows = Math.ceil(panelNumber / panelCols)
        // if (panelRows > panelCols) {
        //   let tmp = panelRows
        //   panelRows = panelCols
        //   panelCols = tmp
        // }
        
        const panelWidth = this.$refs.dashboard.clientWidth / panelCols
        const panelHeight = this.$refs.dashboard.clientHeight / panelRows
        console.log(panelNumber, panelRows, panelCols)
        console.log(this.$refs.dashboard.clientWidth, this.$refs.dashboard.clientHeight)
        console.log(panelWidth, panelHeight)
        this.panels = this.groupData.map((g, i) => {
          return {
            left: `${(i % panelCols) * panelWidth}px`,
            top: `${Math.floor(i / panelCols) * panelHeight}px`,
            width: `${panelWidth}px`,
            height: `${panelHeight}px`,
            ...g,
          }
        })
        // return this.groupData.map((g) => {})
      }
      return []
    },

    getMobileZoomCss(){
      if (this.isMobileDevice){
        return 'mobile-full-screen';
      }else{
        return '';
      }
    },


    zoomPanelClick(panelData) {

      if (!this.zoomPanelData || (this.zoomPanelData && this.zoomPanelData.id != panelData.id)) {
        this.zoomPanelData = panelData
      } else {
        this.zoomPanelData = null
      }

    },
  },
  mounted() {
    this.$nextTick().then(() => {
      this.setupPanel()
      console.log(`panels: `, this.panels)
    })
  },
  components: { VideoPanel },
}
</script>

<style  scoped>

.mobile-full-screen{
    top: 0;
    left: 0;
    width: 100vw;
    position: fixed;
    height: 100vh;
    padding:0;
    z-index:2000;
}
</style>